import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonSkeletonText
} from '@ionic/react';
import classes from './style.module.scss';

const ErListItemLoader = () => {
  return (
    <IonCard className={classes.ionCard} button>
      <div className={classes.mainContainer}>
        <IonGrid>
          <IonRow>
            <IonCol className={classes.ionColNoPad}>
              <IonCardHeader className={classes.headContainer}>
                <IonCardTitle className={classes.erTitle}>
                  <IonSkeletonText
                    style={{ width: '80%', height: '12px' }}
                    animated
                  />
                </IonCardTitle>
                <IonCardSubtitle className={classes.erSubTitle}>
                  <IonSkeletonText
                    style={{ width: '40%', height: '10px' }}
                    animated
                  />
                </IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent>
                <IonSkeletonText
                  style={{ width: '100%', height: '40px' }}
                  animated
                />
                <IonSkeletonText
                  style={{ width: '50%', height: '12px' }}
                  animated
                />
              </IonCardContent>
            </IonCol>
            <IonCol size='4' className={classes.leftCol}>
              <IonSkeletonText
                style={{ width: '100%', height: '80px' }}
                animated
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
      <div className={classes.tagContainer}>
        <IonCardContent>
          <IonSkeletonText style={{ width: '80%', height: '12px' }} animated />
        </IonCardContent>
      </div>
    </IonCard>
  );
};

export default ErListItemLoader;
